import React from 'react'

function Image({ src, onLoad = () => {}}) {
  return <img onLoad={onLoad} alt="gallery" src={src} className={`w-full max-h-full object-contain`} />
}

export default Image
